<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_user') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.user') }} <strong>{{ user.fullname }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-user-new *ngIf="newMode()"></app-user-new>
            <app-user-basedata *ngIf="editMode()" [user]="user" (setEdit)="setEdit($event)"></app-user-basedata>
          </p-tabPanel>

          <p-tabPanel *ngIf="sysMode === 'planner' && user?.showAdditionalData()" header="{{ t('common.labels.languages_locations') }}" leftIcon="pi pi-map-marker" [disabled]="isDisabled('locations') || user === null">
            <app-user-locations *ngIf="editMode()" [user]="user" (setEdit)="setEdit($event)"></app-user-locations>
          </p-tabPanel>

          <p-tabPanel *ngIf="sysMode === 'planner' && user?.showAdditionalData()" header="{{ t('common.labels.procedures') }}" leftIcon="pi pi-clone" [disabled]="isDisabled('templates') || user === null">
            <app-user-templates *ngIf="editMode()" [user]="user" (setEdit)="setEdit($event)"></app-user-templates>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
